import React from 'react'
import { StyledDividerWidthText } from './DividerWidthText.styled'

interface IProps {
  title: string
}

const DividerWidthText = ({ title }: IProps) => {
  return (
    <StyledDividerWidthText>
      <h2>{title}</h2>
      <div className="divider"></div>
    </StyledDividerWidthText>
  )
}

export default DividerWidthText
